function TheGame() {
    /*////////////////////////////////////////////////////////////////////////////////
//standard game logic
     */
    this.gameId = _ndok_app_id;
    this.backgroundcolor = 0x9c96a0;
    this.positionGameItems = positionGameItems;
    this.initGame = initGame;
    this.resetGame = resetGame;
    this.stopGame = stopGame;
    this.startGame = startGame;
    this.cycleGame = cycleGame;
    var gameData = {};
    this.gameData = gameData;
    var sprites;

    var counter;

    

    var itemsPositionsObject ={s_deserto:{x:637 ,y:303 ,w:237,h:61,n:"s_deserto"},s_cactus:{x:654 ,y:116 ,w:62,h:69,n:"s_cactus"},s_sole:{x:648 ,y:208 ,w:73,h:67,n:"s_sole"},s_rami:{x:677 ,y:381 ,w:163,h:62,n:"s_rami"},s_foresta:{x:721 ,y:462 ,w:73,h:69,n:"s_foresta"},s_foglie:{x:748 ,y:198 ,w:109,h:89,n:"s_foglie"},s_cuore:{x:759 ,y:115 ,w:64,h:68,n:"s_cuore"},s_cielo:{x:703 ,y:48 ,w:73,h:51,n:"s_cielo"},d_deserto:{x:217 ,y:288 ,w:237,h:61,n:"d_deserto"},d_cactus:{x:384 ,y:63 ,w:62,h:69,n:"d_cactus"},d_sole:{x:208 ,y:155 ,w:73,h:67,n:"d_sole"},d_rami:{x:296 ,y:202 ,w:163,h:62,n:"d_rami"},d_foresta:{x:183 ,y:63 ,w:73,h:69,n:"d_foresta"},d_foglie:{x:320 ,y:428 ,w:109,h:89,n:"d_foglie"},d_cuore:{x:229 ,y:479 ,w:64,h:68,n:"d_cuore"},d_cielo:{x:320 ,y:353 ,w:73,h:51,n:"d_cielo"}};

/**
     * CORE GAME LOGIC
     */
    function initGame() {
        sprites = game.sprites;

        positionGameItems();

        makeScenes();
        makeCounter();
        document.addEventListener(GameEvents.ANSWER_OK, onAnswerOk, true);
        document.addEventListener(GameEvents.ANSWER_WRONG, onAnswerWrong, true);
        document.addEventListener(GameEvents.EVENT_START_GAME, onStartGame, true);
        document.addEventListener('stopGame', onStopGame, true);
        document.addEventListener('refreshCounter', onRefreshCounter, true);
    }



    function resetGame() {
        resetItems();
        prepareData();
    }

    function startGame() {

        scenesContainer.removeChildren(0, scenesContainer.children.length);
        scenesContainer.addChild(gameData.scene.container);
        onRefreshCounter();
     
        cycleGame();
    }
    function onRefreshCounter(e){
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
    }
    function onStartGame() {

    }

    function onStopGame() {
        end();
    }

    function cycleGame() {

        if (gameData.currentItem < gameData.numItems) {
     
            renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        } else {

            setTimeout(end, 1600);
        }

    }

    function end() {
        stopGame();
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_END_GAME));
        renderer.view.dispatchEvent(new Event(GameEvents.EVENT_CYCLE_GAME));
        loopSequence = [renderOnce];
    }

    function stopGame() {
        gameData.scene.clear();
    }

    function prepareData() {

        gameData.numItems = 8;
        gameData.currentItem = 0;
        gameData.scene = gameScene;
        gameData.scene.reset();
    }


    function makeScenes() {
        scenesContainer = new Container();
        scenesContainer.position.set(285, 0);
        game.gameContainer.addChild(scenesContainer);

        gameScene = new Scene('gioco', itemsPositionsObject,gameData);

    }

    function makeCounter() {
        counter = new ItemsCounter();
        // if (gameData.numItems > 1) {
        game.gameContainer.addChild(counter.container);
        //  }

    }


    function positionGameItems() {
        sprites.btn_gioca.x = 925;
        sprites.btn_gioca.y = 215;
        sprites.btn_gioca.alpha = 0;
    }

    function resetItems() {

    }

    /**
     * GAME LOGIC
     */
    function onAnswerOk(e) {
        renderer.view.dispatchEvent(new Event(GameEvents.GREEN_LIGHT));
        gameData.currentItem++;
        counter.setText(gameData.currentItem + "/" + gameData.numItems);
     

    }

    function onAnswerWrong(e) {
        //  gameData.currentItem++;
        renderer.view.dispatchEvent(new Event(GameEvents.RED_LIGHT));
    }
}


function Scene(sceneName, positions, _gameData) {
    var name = sceneName;
    var gameData=_gameData;
    this.name = name;
    this.reset = reset;
    this.clear = clear;
    var animating;
    var currentState;
    this.setState = setState;
   
    var levels = {};

    levels.level_01 = {       
        container: new Container(),           
        buttons:['foresta','rami','sole','cactus','deserto','foglie','cuore','cielo']
    };
   
    

    var tl = new TimelineMax();
    //
    var container = new Container();
    this.container = container;    
    
   
    var buttonsContainer;


    var gameIndex = 0;
    var sceneElements = {};
    var levelNames = ['01'];

    var currentLevelData;
    var currentLevelContainer;
    var currentLevelName;
    var currentButton;   

    renderer.view.addEventListener(GameEvents.EVENT_CYCLE_GAME, cycled);


    initScene();

    function initScene() {
        var i, ii;

        var spriteItem;
        var pos;

        spriteItem = game.sprites.bg;
        spriteItem.name = 'bg';
        sceneElements.bg=spriteItem;
        container.addChild(spriteItem);
        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            currentLevelData = levels['level_' + currentLevelName];
            currentLevelContainer = currentLevelData.container;
            container.addChild(currentLevelContainer);
            buttonsContainer = new Container();        
            buttonsContainer.interactive = true;
            sceneElements['buttonsContainer_' + currentLevelName] = buttonsContainer;
            for (ii = 0; ii < currentLevelData.buttons.length; ii++) {             
                spriteItem = new Sprite(game.sprites[currentLevelData.buttons[ii]].texture);
                spriteItem.name = 's_'+currentLevelData.buttons[ii];
                pos = positions[spriteItem.name ];
                spriteItem.position.set(pos.x, pos.y); 
                spriteItem.buttonMode = true;
                buttonsContainer.addChild(spriteItem);
                sceneElements[spriteItem.name] = spriteItem;

                spriteItem = new Sprite(game.sprites[currentLevelData.buttons[ii]].texture);
                spriteItem.name = 'd_'+currentLevelData.buttons[ii];
                pos = positions[spriteItem.name ];
                spriteItem.position.set(pos.x, pos.y);               
                spriteItem.interactive=true;
                buttonsContainer.addChild(spriteItem);
                sceneElements[spriteItem.name] = spriteItem;
               
            }


            currentLevelContainer.alpha = 0;
            currentLevelContainer.addChild(buttonsContainer);          
          
            buttonsContainer.on('pointertap', onClick);
        }

    }


    function clear() {


    }

    function reset() {
     currentButton='';
        gameIndex = 0;
        setState('newLevel');
    }

    function resetLevels() {
        var i;

        for (i = 0; i < levelNames.length; i++) {
            currentLevelName = levelNames[i];
            levels['level_' + currentLevelName].container.alpha = 0;        
            sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = false;         
            for (ii = 0; ii <  levels['level_' + currentLevelName].buttons.length; ii++) {
                var baseName=levels['level_' + currentLevelName].buttons[ii];
                spriteItem=sceneElements["s_"+baseName ]  ;         
                spriteItem.alpha=1;
                spriteItem.interactive=true;
                spriteItem=sceneElements["d_"+baseName ]    ;       
                spriteItem.alpha=0;
               
            }        
        }        
    }

    function cycled() {
        setState('ready');
    }

    function setState(state) {

        switch (state) {
            case 'newLevel':
                resetLevels();               
                currentLevelName = levelNames[0];
                currentLevelData = levels['level_' + currentLevelName];                 
                loopSequence = [renderOnce];
                currentLevelContainer = currentLevelData.container;               
                currentLevelContainer.alpha = 1;       
                sceneElements['buttonsContainer_' + currentLevelName].interactiveChildren = true;  
                
                break;
            case 'ready':
                loopSequence = [renderOnce];
                break;
            case 'animating':


                break;
        }
        currentState = state;

    }


function onClick(e) {

    if (currentState === "ready") {
        var clicked = e.target.name;
       
        if (clicked.indexOf('s_') > -1) {
             var buttonName=clicked.substr(2);
            //se non è stato usato
            if (currentButton !== ''){
                sceneElements['s_'+currentButton].alpha=sceneElements['s_'+currentButton].alpha===0?0:1;
            }
          
            if (sceneElements[clicked].alpha > 0) {
                currentButton = buttonName;
                sceneElements[clicked].alpha = 0.5;            
            }

        } else {
            //bottone to
            if (currentButton !== '') {
                var ok = false;
console.log(clicked,currentButton)
                if (clicked.indexOf(currentButton) === 2 && sceneElements[clicked].alpha === 0) {
                    ok =true;                   
                        sceneElements['s_'+currentButton].alpha = 0;   
                        sceneElements[clicked].alpha = 1;   
                         
                } else {
                    sceneElements['s_'+currentButton].alpha = 1;
                }
                currentButton = '';
                if (ok) {
                 
                    setState('animating');
                    renderer.view.dispatchEvent(new Event('answerOk'));
                    setTimeout(okComplete, 1000);
                } else {
                    setState('animating');
                    renderer.view.dispatchEvent(new Event('answerWrong'));
                    setTimeout(wrongComplete, 1000);
                }
            }
        }
        loopSequence = [renderOnce];
    }
}

    function okComplete() {

      /*  gameIndex++;
        if (gameIndex < 3) {
            setState('newLevel');
        }*/
        theGame.cycleGame();
        loopSequence = [renderOnce];

    }
   

    function wrongComplete() {
        // gameIndex++;
        theGame.cycleGame();

        //  setState('ready');
        //  loopSequence = [renderOnce];
    }
}